document.addEventListener("DOMContentLoaded", function() {

    const filter = document.querySelector(".block-filter .js-modal");

    window. addEventListener("resize", function() {

        if(window.innerWidth >= 990) {

            if(filter) {

                filter.classList.remove("fade-out");

            }
        }
    });
});